var __jsx = React.createElement;
import React, { useEffect, useState } from 'react';
import MuscleModal from '../../../components/modal';
import CustomerRegisterForm from './components/customer-register-form';
import ErrorInFlowModal from './components/error-in-flow-modal';
import SuccessValidatingIdModal from './components/success-validating-id-modal';
import { useActiveContent } from '@lib/context/shared/active-content-context';
import MuscleGuestRegistrationPage from '@modules/flow-independent-pages/guest-registration-page/page';
import useAfterInitEffect from '@lib/hooks/use-after-initialization-effect';
import { permissionsManager } from "@lib/permissions/permissions-manager";
const RegisterFlow = _ref => {
  let {
    isOpen,
    setIsOpen,
    onCloseCallback,
    overrideClosingAction = false
  } = _ref;
  const allowGuestUsers = permissionsManager.allowUnauthenticatedUsers() && !permissionsManager.useEntityLogin();
  return __jsx(React.Fragment, null, allowGuestUsers ? __jsx(GuestUserRegisterFlow, {
    isOpen: isOpen,
    setIsOpen: setIsOpen,
    onCloseCallback: onCloseCallback,
    overrideClosingAction: overrideClosingAction
  }) : __jsx(AuthenticatedUserRegisterFlow, {
    isOpen: isOpen,
    setIsOpen: setIsOpen,
    onCloseCallback: onCloseCallback,
    overrideClosingAction: overrideClosingAction
  }));
};
const GuestUserRegisterFlow = _ref2 => {
  let {
    isOpen,
    setIsOpen,
    onCloseCallback,
    overrideClosingAction = false
  } = _ref2;
  const {
    changeActiveContent,
    setActiveContentToDefault
  } = useActiveContent();
  useAfterInitEffect(() => {
    if (isOpen) {
      changeActiveContent(__jsx(MuscleGuestRegistrationPage, {
        onClose: () => {
          onCloseCallback && onCloseCallback();
          if (overrideClosingAction) {
            return;
          }
          setIsOpen(false);
          setActiveContentToDefault('register flow closed');
        }
      }));
    }
  }, [isOpen]);
  return __jsx(React.Fragment, null);
};
const AuthenticatedUserRegisterFlow = _ref3 => {
  let {
    isOpen,
    setIsOpen
  } = _ref3;
  const {
    0: errorModalIsOpen,
    1: setErrorModalIsOpen
  } = useState(false);
  const {
    0: idValidationSuccessModalIsOpen,
    1: setIdValidationSuccessModalIsOpen
  } = useState(false);
  const {
    0: customerEmail,
    1: setCustomerEmail
  } = useState('');
  const {
    0: idType,
    1: setIdType
  } = useState('');
  const {
    0: idNumber,
    1: setIdNumber
  } = useState('');
  const {
    0: errorCode,
    1: setErrorCode
  } = useState('');
  useEffect(() => {
    if (isOpen) {
      setErrorModalIsOpen(false);
      setIdValidationSuccessModalIsOpen(false);
      setCustomerEmail('');
      setIdType('');
      setIdNumber('');
      setErrorCode('');
    }
  }, [isOpen]);
  const onSuccessValidatingId = (customerEmail, idType, idNumber) => {
    setIdType(idType);
    setIdNumber(idNumber);
    setCustomerEmail(customerEmail);
    setIdValidationSuccessModalIsOpen(true);
    setIsOpen(false);
  };
  const onErrorValidatingId = errorCode => {
    setErrorCode(errorCode);
    setErrorModalIsOpen(true);
    setIsOpen(false);
  };
  const onErrorSendingEmail = errorCode => {
    setErrorCode(errorCode);
    setErrorModalIsOpen(true);
    setIdValidationSuccessModalIsOpen(false);
  };
  return __jsx(React.Fragment, null, __jsx(MuscleModal, {
    dataTestId: "register-modal",
    openState: isOpen,
    setOpenState: setIsOpen
  }, __jsx(CustomerRegisterForm, {
    onSuccessValidatingId: onSuccessValidatingId,
    onErrorValidatingId: onErrorValidatingId
  })), __jsx(ErrorInFlowModal, {
    dataTestId: "register-error-modal",
    isOpen: errorModalIsOpen,
    setIsOpen: setErrorModalIsOpen,
    errorCode: errorCode
  }), __jsx(SuccessValidatingIdModal, {
    dataTestId: "register-success-modal",
    isOpen: idValidationSuccessModalIsOpen,
    setIsOpen: setIdValidationSuccessModalIsOpen,
    onErrorSendingEmail: onErrorSendingEmail,
    idType: idType,
    idNumber: idNumber,
    customerEmail: customerEmail
  }));
};
export default RegisterFlow;